import { GlobalCard } from '@global-engineering-shared/gweb-material-global';
import { InfoIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import { useEffect, useState } from 'react';

import useStyles from 'features/Drafts/components/OverrideUploadInProgressCard/OverrideUploadInProgressCard.styles';
import useFetchData from 'hooks/useFetchData';
import { TASKS_API_URL } from 'utils/defaults';

interface IOverrideServiceStatus {
  tasksProcessing: boolean;
}

const OverrideUploadInProgressCard = () => {
  const classes = useStyles();
  const [tasksProcessing, setTasksProcessing] = useState(false);
  const { getData } = useFetchData();

  useEffect(() => {
    getData<IOverrideServiceStatus>(TASKS_API_URL, (response) => {
      setTasksProcessing(response.tasksProcessing);
    });
  }, []);

  if (!tasksProcessing) {
    return null;
  }

  return (
    <GlobalCard className={classes.card}>
      <Box className={classes.alertIcon}>
        <InfoIcon />
      </Box>
      <Box>
        <Typography variant="body2">
          Inventory data is being processed. Please come back soon to see new drafts.
        </Typography>
      </Box>
    </GlobalCard>
  );
};

export default OverrideUploadInProgressCard;
